import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initPhoneClickTracking } from './utils/phoneClickTracking';
import { initContactClickTracking } from './utils/contactClickTracking';

initPhoneClickTracking();
initContactClickTracking();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
